import React from "react";
import { Small } from "components/Typography";
import { FlexBox } from "components/flex-box";
import { colors } from "common";
import { SxProps } from "@mui/material";
import { Theme } from "@mui/system";

interface Props {
  title?: string;
  subTitle?: string;
}

const sxStyles: { [key: string]: SxProps<Theme> } = {
  container: {
    backgroundColor: colors.common.white,
    borderRadius: 1,
    border: 1,
    padding: 2,
    borderColor: colors.grey[300],
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    mt: 1,
  },
  title: {
    fontWeight: 700,
    color: colors.red[600],
    textAlign: "center",
  },
  note: {
    paddingTop: 1,
    textAlign: "center",
  },
};

const component: React.FC<Props> = ({ title, subTitle }) => {
  return (
    <FlexBox sx={sxStyles.container}>
      <Small sx={sxStyles.title}>{title}</Small>
      <Small sx={sxStyles.note}>{subTitle}</Small>
    </FlexBox>
  );
};

export const CheckoutAnnouncement = React.memo(component);
